$ = require 'jquery'
Browser = require '@trello/browser'
f = require 'effing'
{ Key } = require '@trello/keybindings'
Layout = require 'app/scripts/views/lib/layout'
PopOverReact = require 'app/scripts/views/lib/pop-over-react'
Promise = require 'bluebird'
View = require 'app/scripts/views/internal/view'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
{ Key, registerShortcut, Scope, unregisterShortcut } = require '@trello/keybindings'
{ track } = require '@trello/analytics'
{ shouldHandleWindowsFrame } = require '@trello/desktop'
Util = require 'app/scripts/lib/util'
WindowSize = require 'app/scripts/lib/window-size'
ReactWrapper = require 'app/scripts/lib/react/backbone-view-wrapper'
xtend = require 'xtend'
_ = require 'underscore'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ registerClickOutsideHandler, unregisterClickOutsideHandler, ELEVATION_ATTR, getElevation, getHighestVisibleElevation } = require '@trello/layer-manager'

HEADER_HEIGHT = 44
DESKTOP_OFFSET = 32

if (shouldHandleWindowsFrame())
  HEADER_HEIGHT = HEADER_HEIGHT + DESKTOP_OFFSET

module.exports = new class
  $body = null
  $po = null
  elem = null
  fnOnHide = null
  positionInterval = null

  onShortcut: (event) =>
    @popView()
    # we assume popovers are always the topmost item, so if we close them on Esc
    # it is safe to stop the event from bubbling, this was added specifically to
    # handle the case where a Power-Up has a modal up, and a popover is opened above it
    event.stopImmediatePropagation()
    track 'Keyboard Shortcuts', 'Esc - Pop Pop-over View', 'Pop Over'

  constructor: ->
    @argsStack = []
    @position = {}
    @isVisible = false
    @hardToClose = false
    @displayType = ''

  init: ->
    $body = $('body')
    $po = $('.pop-over')

    # Popover Events
    @handleClickOutside = @handleClickOutside.bind(this)

  handleClickOutside: (e) ->
    # We aren't interested in this event if the popover is not visible
    if !@isVisible
      return

    # Determine whether the click outside was actually on one of the popover triggers,
    # in which case we should ignore it and let the trigger handle toggling
    wasTriggerClick = @argsStack.some (args) ->
      if !args.elem
        return false
      element = $(args.elem)[0]
      element.contains(e.target)

    if wasTriggerClick
      return

    @hide()

  contains: (el) ->
    $.contains($po[0], el)

  toggledBy: (el) ->
    _.any(@argsStack, (arg) -> arg.elem == el)

  # Make sure the popover is still visible when the window is resized
  onWindowResize: ->
    return if !@isVisible

    @load @argsStack.pop()

  getWindowHeight: ->
    windowHeight = $(window).height()
    if (shouldHandleWindowsFrame())
      windowHeight = windowHeight - 32
    return windowHeight

  resetTopWhenBeyondBottom: (po_top, po_bottom, po_height) ->
    _po_top = po_top
    windowHeight = @getWindowHeight()
    if WindowSize.fLarge or WindowSize.fExtraLarge
      s_height = windowHeight + $(window).scrollTop()
      if po_bottom > s_height
        _po_top = s_height - po_height - 8
      if po_height > s_height - HEADER_HEIGHT
        _po_top = HEADER_HEIGHT

    return _po_top

  # Return the new position of the popover
  calcPos: (args) ->
    windowWidth = $(window).width()
    windowHeight = @getWindowHeight()

    if args.maxWidth?
      if args.maxWidth > windowWidth
        $po.width(windowWidth - 16)
      else
        $po.width(args.maxWidth)

    else
      $po.width("")

    max_right = windowWidth
    w_height = windowHeight
    po_width = $po.outerWidth()

    elementIsVisible = args.elem? && $(args.elem).is(':visible')

    if elementIsVisible

      if args.top?
        top = args.top
      else if args.elem? # would be in a pretty bad state if this were false…
        top = $(args.elem).outerHeight() + 6
      else
        top = 35 # an arbitrary default… could break w/o it.

      if args.alignRight
        el_left = $(args.elem).offset().left + $(args.elem).outerWidth() - po_width
      else
        el_left = $(args.elem).offset().left
      el_top = $(args.elem).offset().top + top

      # if desktop and windows account for the frame height
      if (shouldHandleWindowsFrame())
        el_top = el_top - 32

    else if args.clientx? && args.clienty?
      el_left = args.clientx
      el_top = args.clienty

    # magic number alert! 68 is the height of the global header and a little
    # extra padding for the bottom. we don't want to pop over to overflow past
    # the bottom of the screen.
    poMaxHeight = w_height - 68
    if !args.hideHeader
      poMaxHeight -= $po.find('.js-pop-over-header').outerHeight()

    # if there is no hook element or it's hidden, don't bother try to position anything
    # prevents wacky jump when trying to change label names and some otherview pops.
    # if we are clicking the board to add a list (clientx, clienty), DO show the board
    if (
      !(args.clientx? && args.clienty?) &&
      (!elementIsVisible || !_.include(['block', 'inline-block', 'inline', 'table-cell', 'flex'], $(args?.elem).css('display')))
    )
      return

    # TOP

    # ensure that the top of the element is visible
    po_top = if el_top > 0 then el_top else 5
    po_height = $po.outerHeight()
    po_bottom = po_top + po_height

    po_top = @resetTopWhenBeyondBottom(po_top, po_bottom, po_height)

    # LEFT

    po_left = if el_left > 0 then el_left else 5
    el_right = po_left + po_width + 16

    # we want to ensure the right corner is on the screen
    if el_right > max_right
      # move the element back onto the screen
      po_left = max_right - (po_width + 5)

    # make sure the original args.elem is not overlaid
    if args.elem

      elemTop = $(args.elem).offset().top
      if (shouldHandleWindowsFrame())
        elemTop = elemTop - DESKTOP_OFFSET

      if po_top <= elemTop + $(args.elem).outerHeight() && po_bottom >= elemTop
        # reposition the popup above the target element
        po_top = elemTop - po_height - 6 # 6 is the same padding used above
        # ensure that the top of the popup is top above the screen
        if po_top < HEADER_HEIGHT
          po_top = HEADER_HEIGHT
          po_bottom = po_top + po_height
        else
          po_bottom = po_top + po_height
          po_top = @resetTopWhenBeyondBottom(po_top, po_bottom, po_height)

    {
      left: po_left
      top: po_top
      contentHeight: poMaxHeight
    }

  # Loads the supplied view into $po and sets all the applicable class fields
  load: (args) ->
    # We have to set PopOver.view. Hopefully some day we won't have to do this,
    # but for now the rest of the app assumes we're wont to do it.
    @view = args.view
    @hardToClose = args.hardToClose
    # Add special CSS classes for special types of popovers
    @displayType = args.displayType
    $po.addClass(@displayType)

    #
    # React!
    #

    if !React.isValidElement args.reactElement
      throw new Error("PopOver args.reactElement has to be a react element")

    children =
      if _.last(@argsStack)?.keepInDOM
        oldChildren = _.chain(@argsStack).filter((args) -> args.keepInDOM).pluck('reactElement').value()
        oldChildren.concat(args.reactElement)
      else
        [args.reactElement]

    props =
      key: "PopOver"
      onBack: if @argsStack.length > 0 then => @popView() else null
      onClose: f @, 'hide'
      getViewTitle: args.getViewTitle
      hasSafeViewTitle: args.hasSafeViewTitle
      hideHeader: args.hideHeader

    @por = ReactDOM.render(
      React.createElement(PopOverReact, props, children),
      $po[0]
    )

    show = =>
      # Position the popover. We do this here because we need to render it first to calculate its position.
      @position = @calcPos(args) ? @position

      $po.css
        left: @position.left
        top: @position.top

      $po.find('.js-pop-over-content').css
        maxHeight: @position.contentHeight

      $po.addClass 'is-shown'
      $po.trigger 'is-shown'

    if args.showImmediately
      show()
    else
      _.defer show

    @argsStack.push args

  # We have legacy code that puts some properties on the view, but now we expect these properties on args.
  # If there are conflicts, args takes precedence.
  extractViewArgs: (args) ->
    # If there's a react element already, then it's using the new style
    return args if args.reactElement?

    # Sometimes we just get a view
    if !args.view?
      args = { view: args }

    # If you pass a view class, instantiate it here
    if _.isFunction(args.view)
      args.view = new args.view(args.options ? {})

    # Now we have the view, check that it's a backbone view
    if !(args.view instanceof View)
      throw new Error("PopOver args.view has to be a backbone instance")

    extractViewFunction = (view, name) ->
      if _.isFunction(view[name]) then f(view, name)

    args.reactElement = React.createElement ReactWrapper, { key: args.view.cid, view: args.view }

    xtend {
        maxWidth: args.view.maxWidth
        displayType: args.view.displayType
        keepInDOM: args.view.keepInDOM
        hideHeader: args.view.hideHeader
        getViewTitle: extractViewFunction(args.view, 'getViewTitle')
        hasSafeViewTitle: args.view.hasSafeViewTitle
        willBePushedDown: extractViewFunction(args.view, 'willBePushedDown')
        willBePopped: extractViewFunction(args.view, 'willBePopped')
      }, args

  show: (args) ->
    # reset
    if !args.keepEdits
      Layout.cancelEdits(args.elActive)

    # Calculate the data-elevation attribute on the popover for interop with @trello/layer-manager
    # If we aren't positioning our popover relative to some element, just increment the highest
    # visible elevation. If we _are_ positioning relative to some element, increment its elevation
    # instead.
    # We want to calculate this _before_ reseting the popover to ensure that 'nested' Popovers that are shown
    # via a Popover.toggle() (NOT a pushView) continue to incement their elevation based on their anchoring
    # element (which may itself be inside a Popover)
    targetDomNode = args.elem && $(args.elem)[0]
    elevation = if targetDomNode then getElevation(targetDomNode) + 1 else getHighestVisibleElevation() + 1

    @reset()

    # Add the elevation attribute as data-elevation
    $po.attr(ELEVATION_ATTR, elevation)

    @load(@extractViewArgs(args))

    _.defer =>
      if $po.find('.js-autofocus').length > 0
        return if (Browser.isTouch() && $po.find('.js-autofocus:first').hasClass('js-no-touch-autofocus'))
        $po.find('.js-autofocus:first').focus().select()

    @isVisible = true
    args.shown?($po)
    fnOnHide = args.hidden

    @positionInterval = setInterval(@checkPosition.bind(@), 150)

    registerShortcut(@onShortcut, { scope: Scope.Popover, key: Key.Escape })

    # Register an 'outside click' handler that takes elevations into account
    registerClickOutsideHandler($po[0], @handleClickOutside)

    # Adds an overlay on top of Power-Up iframes so that click events are captured
    # to ensure that Popovers are closed when clicking outside of the popover.
    $('.js-plugin-iframe-container').addClass('plugin-iframe-container-pop-over-shown')

    return

  # We don't really know what's going on in the popover; it might re-render and
  # get bigger than it is right now.  The simplest thing we can do is
  # periodically check and see if we've expanded beyond the bottom of the screen
  # and if so, move the popover up until everything is visible again
  # Also, they might have scrolled and made the popover go of the screen
  checkPosition: ->
    if !@isVisible
      clearInterval(@positionInterval)
      return

    popoverTop = $po.offset().top
    windowScrollTop = $(window).scrollTop()
    if popoverTop == windowScrollTop
      # We can't move the dialog up anymore; don't even bother
      return

    windowHeight = @getWindowHeight()
    popoverHeight = $po.outerHeight()

    if popoverTop < windowScrollTop && popoverHeight <= windowHeight
      # They've scrolled down, keep the popover in view
      $po.css({ top: windowScrollTop })
      return

    if popoverTop + popoverHeight > windowScrollTop + windowHeight
      # The popover is extending beyond the bottom of the screen
      newTop = windowScrollTop + Math.max(0, windowHeight - popoverHeight)
      if newTop != popoverTop
        $po.css
          top: newTop

  pushView: (args) ->
    @clearDisplayTypes()

    oldArgs = _.last(@argsStack)
    oldArgs?.willBePushedDown?()

    @load(@extractViewArgs(args))

    if $po.find('.js-autofocus').length > 0
      return if (Browser.isTouch() && $po.find('.js-autofocus:first').hasClass('js-no-touch-autofocus'))
      setTimeout =>
        $po.find('.js-autofocus:first').focus().select()
      , 10

  popView: (depth = 1) ->
    @clearDisplayTypes()

    for i in [0...depth]
      oldArgs = _.last(@argsStack)
      oldArgs?.willBePopped?()
      oldArgs?.reactElement.props?.view?.remove()

      @argsStack.pop()

      if !_.last(@argsStack)?
        @hide()
        return

    # reload view without rerendering so we don't lose any in-progress input
    args = @argsStack.pop()
    args?.willBePushedUp?()
    @load args

    # wait to focus input because it stops the animation if we
    # focus while animating
    if $po.find('.js-autofocus').length > 0
      return if (Browser.isTouch() && $po.find('.js-autofocus:first').hasClass('js-no-touch-autofocus'))
      setTimeout =>
        $po.find('.js-autofocus:first').focus().select()
      , 10

  toggle: (args) ->
    # We want to hide when we're triggered on the same element. However,
    # the elem argument can either be a jQuery selection or a normal DOM
    # element, so we normalize here.
    isSameElement = (e1, e2) ->
      e1 && e2 && $(e1)[0] == $(e2)[0]

    if _.last(@argsStack) && isSameElement(_.last(@argsStack).elem, args.elem)
      @hide()
    else
      @show(args)

  hide: ->
    clearInterval(@positionInterval)

    $po.removeClass('is-shown')

    lastArgStack = _.last(@argsStack)

    $body.trigger 'popover-hide', { elem: lastArgStack?.elem }

    @reset()

    if $po?[0]
      ReactDOM.unmountComponentAtNode($po[0])

    if lastArgStack?.onClose?
      lastArgStack.onClose()

    # Removes the overlay on top of Power-Up iframes so that they are clickable again.
    $('.js-plugin-iframe-container').removeClass('plugin-iframe-container-pop-over-shown')

  reset: ->
    @clearDisplayTypes()

    for args in @argsStack by -1
      args.willBePopped?()
      args.reactElement.props?.view?.remove()

    unregisterShortcut(@onShortcut)
    $po.removeAttr(ELEVATION_ATTR)
    unregisterClickOutsideHandler($po[0], @handleClickOutside)

    # Other views reference PopOver.view.
    @view = null

    @argsStack = []
    @isVisible = false
    @hardToClose = false
    @por = null
    fnOnHide?($po)
    fnOnHide = null

  clearDisplayTypes: ->
    classes = [
      'mod-mini-profile'
      'mod-avdetail'
      'mod-search-over'
      'mod-no-header'
      'mod-reaction-selector'
      @displayType
    ]
    $po.removeClass(classes.join(' '))

  clearStack: ->
    @argsStack = []
